import React from 'react';
import '../../styles/components/PlaceholderImage.css';

interface PlaceholderImageProps {
  id: string;
  label: string;
  width?: number;
  height?: number;
  shape?: 'circle' | 'rectangle';
  initials?: string;
  className?: string;
}

const isImagePath = (id: string) =>
  id.startsWith('/') || id.startsWith('http') || id.endsWith('.png') || id.endsWith('.jpg') || id.endsWith('.webp');

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  id,
  label,
  width = 200,
  height = 200,
  shape = 'rectangle',
  initials,
  className = '',
}) => {
  if (isImagePath(id)) {
    const webpSrc = id.endsWith('.webp') ? id : id.replace(/\.(png|jpg|jpeg)$/, '.webp');
    const jpgSrc = id.replace(/\.(png|webp)$/, '.jpg');
    const imgStyle = { width, height: shape === 'circle' ? width : height, objectFit: 'cover' as const };
    const imgClass = `placeholder-image placeholder-image--${shape} ${className}`;

    return (
      <picture>
        <source srcSet={webpSrc} type="image/webp" />
        <img
          src={jpgSrc}
          alt={label}
          className={imgClass}
          style={imgStyle}
          loading="lazy"
        />
      </picture>
    );
  }

  return (
    <div
      className={`placeholder-image placeholder-image--${shape} ${className}`}
      style={{ width, height: shape === 'circle' ? width : height }}
      role="img"
      aria-label={label}
      data-placeholder-id={id}
    >
      {initials ? (
        <span className="placeholder-image__initials">{initials}</span>
      ) : (
        <span className="placeholder-image__label">{label}</span>
      )}
    </div>
  );
};

export default PlaceholderImage;
